export const aciFilter = {
    iconName: 'filter',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M20.595 4.591A.553.553 0 0020.042 4H4.554a.554.554 0 00-.553.591 8.32 8.32 0 006.632 7.555v7.3a.555.555 0 00.91.426l2.217-1.848a.554.554 0 00.2-.426v-5.452a8.319 8.319 0 006.635-7.555z',
                stroke: 'currentColor',
                'stroke-width': '1.215',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
